import { render, staticRenderFns } from "./OnboardConnect.vue?vue&type=template&id=98b9d514&"
import script from "./OnboardConnect.vue?vue&type=script&lang=js&"
export * from "./OnboardConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports